import {register} from '../vendor/theme-scripts/theme-sections';
import parallaxImage from '../features/image-parallax';
import scrollButton from '../features/scroll-button';

register('hero', [parallaxImage, scrollButton]);
